const CommonStyling = {
  arrowButton: {
    transform: 'rotate(90deg)',
    height: '75px',
    marginBottom: '15px'
  },
  icon: {
    height: '75px',
    marginBottom: '15px'
  }
}

export default CommonStyling



/** WEBPACK FOOTER **
 ** ./src/app/components/startView/shared/commonStyling.js
 **/